import { DrugKeys } from '../util/config/constants';

import { emgalityTerms } from './emgality';
import {
    foundayoPathwayAlerts,
    foundayoPathwayOptions,
    foundayoQuestionnaire,
    foundayoTerms,
} from './foundayo';
import { mounjaroTerms } from './mounjaro';
import type { ProgramContentData } from './shared';
import { trulicityTerms } from './trulicity';
import {
    zepboundAutoinjectorPathwayAlerts,
    zepboundAutoinjectorPathwayOptions,
    zepboundAutoinjectorQuestionnaire,
    zepboundAutoinjectorTerms,
} from './zepbound/autoinjector';
import {
    zepboundKwikpenPathwayAlerts,
    zepboundKwikpenPathwayOptions,
    zepboundKwikpenQuestionnaire,
    zepboundKwikpenTerms,
} from './zepbound/kwikpen';
import {
    zepboundVialPathwayAlerts,
    zepboundVialPathwayOptions,
    zepboundVialTerms,
} from './zepbound/vial';

const lillyDirect: ProgramContentData = {
    pathwayAlerts: {
        [DrugKeys.Orfo]: foundayoPathwayAlerts,
        [DrugKeys.ZepboundAutoinjector]: zepboundAutoinjectorPathwayAlerts,
        [DrugKeys.ZepboundKwikPen]: zepboundKwikpenPathwayAlerts,
        [DrugKeys.ZepboundVial]: zepboundVialPathwayAlerts,
    },
    pathwayQuestionnaire: {
        [DrugKeys.Orfo]: foundayoQuestionnaire,
        [DrugKeys.ZepboundAutoinjector]: zepboundAutoinjectorQuestionnaire,
        [DrugKeys.ZepboundKwikPen]: zepboundKwikpenQuestionnaire,
    },
    pathwayOptions: {
        [DrugKeys.Orfo]: foundayoPathwayOptions,
        [DrugKeys.ZepboundAutoinjector]: zepboundAutoinjectorPathwayOptions,
        [DrugKeys.ZepboundKwikPen]: zepboundKwikpenPathwayOptions,
        [DrugKeys.ZepboundVial]: zepboundVialPathwayOptions,
    },
    terms: {
        [DrugKeys.Emgality]: emgalityTerms,
        [DrugKeys.Orfo]: foundayoTerms,
        [DrugKeys.Mounjaro]: mounjaroTerms,
        [DrugKeys.Trulicity]: trulicityTerms,
        [DrugKeys.ZepboundAutoinjector]: zepboundAutoinjectorTerms,
        [DrugKeys.ZepboundKwikPen]: zepboundKwikpenTerms,
        [DrugKeys.ZepboundVial]: zepboundVialTerms,
    },
};

export default lillyDirect;
